import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useEffect, useState } from "react";
import styles from "./styles.module.scss";
import TextAreaInput from "../textAreaInput/textArea";
const RadioButton = (props) => {
    const changeHandler = (e) => {
        props.setValue(e.currentTarget.value);
        setTouched(true);
    };
    const [touched, setTouched] = useState(false);
    const isChecked = () => {
        if (typeof props.checked === "string")
            return props.checked === props.value;
        return props.checked.includes(props.value);
    };
    const isUndefined = () => typeof props.checked === "undefined" || props.checked.length === 0;
    const handleCheckStyles = () => {
        if (isChecked()) {
            return styles.btn_checked;
        }
        if (isUndefined()) {
            return styles.btn_init;
        }
        return styles.btn_unchecked;
    };
    const onChangeFreeForm = (string) => {
        props.setFreeFormValue && props.setFreeFormValue(string);
    };
    useEffect(() => {
        handleCheckStyles();
    }, [props.checked]);
    useEffect(() => {
        if (props.autoNext && props.value && props.value.length && touched) {
            props.goNext();
            setTouched(false);
        }
    }, [touched, props.value]);
    return (
    // if we set htmlfor attr we cant trigger check by click on its label
    _jsxs("label", { htmlFor: props.labelFor || props.value, className: `${styles.label_container} ${props.extraClassName} `, children: [_jsx("input", { id: props.labelFor || props.value, type: "radio", value: props.value, onChange: changeHandler, name: props.value, checked: isChecked() }), _jsxs("div", { className: `${styles.btn} ${handleCheckStyles()} ${props.iconRaw && styles.iconbtn} ${isChecked() && props.isFreeForm && styles.free_form}`, children: [props.iconRaw && _jsx("div", { className: styles.img_container, dangerouslySetInnerHTML: { __html: props.iconRaw } }), _jsx("span", { className: styles.label, children: props.text.toLocaleUpperCase() }), isChecked() && props.isFreeForm && (_jsx(TextAreaInput, { setValue: onChangeFreeForm, placeholder: "Let Us Know", value: props.freeFormValue, extraClassName: styles.free_form_input, rows: 4, maxLength: 400 }))] })] }));
};
export default memo(RadioButton);
